import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";
import { path } from "../../config";

export function* onLoadHomeSpecialOffer() {
  yield takeEvery(actionTypes.HOME_SPECIAL_OFFER, function* (action) {
    try {
      const response = yield API.loadVoucherList(action.data, null, null);
      if (response.data.success) {
        yield put(actions.onLoadHomeSpecialOfferSuccess(response.data));
      } else {
        // console.log("Fail to load home special offer: ", response.data.message);
      }
    } catch (error) {
      //   console.log("Fail to load home special offer: ", error);
      yield put(actions.handleAPIError(error));
    }
  });
}

export function* getVoucherDetail() {
  yield takeEvery(actionTypes.LOAD_VOUCHER_DETAILS, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.loadVoucherDetail(action.id);

      if (response.data.success) {
        yield put(actions.getVoucherDetailSuccess(response.data.data));
      } else {
        if (document.referrer === window.location.href) {
          window.location = path;
        } else {
          alert(
            "Warning: Fail to get voucher details. \n" + response.data.message
          );
          window.location = document.referrer;
        }
      }
      yield put(actions.disableLoading());
    } catch (error) {
      if (document.referrer === window.location.href) {
        window.location = path;
      } else {
        alert(
          "Error: Fail to get voucher details. \n" + API.constructErrMsg(error)
        );
        window.location = document.referrer;
      }
      yield put(actions.disableLoading());
    }
  });
}

export function* getMyVoucherDetail() {
  yield takeEvery(actionTypes.LOAD_MY_VOUCHER_DETAILS, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.loadMyVoucherDetail(action.id);

      if (response.data.success) {
        yield put(actions.getMyVoucherDetailsSuccess(response.data.data));
      } else {
        if (document.referrer === window.location.href) {
          window.location = path;
        } else {
          alert(
            "Warning: Fail to get voucher details. \n" + response.data.message
          );
          window.location = document.referrer;
        }
      }
      yield put(actions.disableLoading());
    } catch (error) {
      if (document.referrer === window.location.href) {
        window.location = path;
      } else {
        alert(
          "Error: Fail to get voucher details. \n" + API.constructErrMsg(error)
        );
        window.location = document.referrer;
      }
      yield put(actions.disableLoading());
    }
  });
}

export function* loadVoucherMediaFood() {
  yield takeEvery(actionTypes.LOAD_VOUCHER_FOODMEDIA, function* (action) {
    yield put(actions.enableLoading());
    try {
      let params = {
        id: action.data.id,
        offset: action.data.offset,
        limit: action.data.limit,
      };
      const response = yield API.loadVoucherFoodMedia(params);

      if (response.data.success) {
        yield put(
          actions.loadVoucherFoodMediaSuccess(
            response.data,
            response.data.total
          )
        );
      } else {
        alert(
          "Warning: Fail to load voucher image. \n" + response.data.message
        );
      }
      yield put(actions.disableLoading());
    } catch (error) {
      alert(
        "Error: Fail to load voucher image. \n" + API.constructErrMsg(error)
      );
      yield put(actions.disableLoading());
    }
  });
}

// MyVoucher
export function* getMyVoucherList() {
  yield takeEvery(actionTypes.GET_MY_VOUCHER_LIST, function* (action) {
    try {
      const response = yield API.loadMyVoucher(action.data);
      if (response.data.success) {
        yield put(actions.getMyVoucherListSuccess(action.data, response.data));
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      yield put(actions.handleAPIError(error));
      let msg = API.constructErrMsg(error);
      yield put(actions.getMyVoucherListFail(msg));
    }
  });
}

// Promo
export function* getPromo() {
  yield takeEvery(actionTypes.GET_PROMO, function* (action) {
    try {
      const response = yield API.loadPromo(action.data);
      if (response.data.success) {
        yield put(actions.getPromoSuccess(action.data, response.data));
      } else {
        yield put(actions.getPromoFail());
      }
    } catch (error) {
      yield put(actions.getPromoFail());
      let msg = API.constructErrMsg(error);
      alert(
        msg.toLowerCase().includes("not found")
          ? 'No "' + action.data.promo_code + '" promo code found.'
          : msg
      );
      //   yield put(actions.handleAPIError(error));
    }
  });
}
export function* clearPromo() {
  yield takeEvery(actionTypes.CLEAR_PROMO, function* (action) {});
}
// Voucher Refund
export function* refundVoucher() {
  yield takeEvery(actionTypes.REFUND_VOUCHER, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.refundVoucher(action.data);
      if (response.data.success) {
        yield put(actions.toastSuccess(response.data.message));
        yield put(actions.refundVoucherSuccess());
      } else {
        alert(response.data.message);
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
    }
  });
}
// Voucher Redeem
export function* redeemVoucher() {
  yield takeEvery(actionTypes.REDEEM_VOUCHER, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.redeemedVoucher(action.data);
      if (response.data.success) {
        yield put(actions.redeemVoucherSuccess());
      } else {
        alert(response.data.message);
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
    }
  });
}

// Load Voucher
export function* loadVoucherList() {
  yield takeEvery(actionTypes.LOAD_VOUCHER_LIST, function* (action) {
    try {
      const response = yield API.loadVoucherList(
        action.data,
        action.restID,
        action.status !== "rest_all" ? action.status : null
      );

      if (response.data.success) {
        yield put(actions.loadVoucherListSuccess(action.status, response.data));
      } else {
        yield put(actions.loadVoucherListFail());
        alert(response.data.message);
      }
    } catch (error) {
      yield put(actions.loadVoucherListFail());
      yield put(actions.handleAPIError(error));
    }
  });
}

// Buy Voucher
export function* buyVoucher() {
  yield takeEvery(actionTypes.BUY_VOUCHER, function* (action) {
    try {
      const response = yield API.buyVoucher(action.data);
      if (response.data.success) {
        yield put(actions.buyVoucherSuccess());
      } else {
        alert(response.data.message);
        yield put(actions.buyVoucherFail(response.data.message));
      }
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.buyVoucherFail("Fail"));
    }
  });
}

// Load All Voucher
export function* loadAllVoucher() {
  yield takeEvery(actionTypes.LOAD_ALL_VOUCHER, function* (action) {
    try {
      const response = yield API.loadVoucherList(action.data, null, null);
      if (response.data.success) {
        yield put(actions.loadAllVoucherSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadAllVoucherFail(response.data.message));
      }
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.loadAllVoucherFail("Fail to load voucher"));
    }
  });
}

export default function* voucherSaga() {
  yield all([
    fork(onLoadHomeSpecialOffer),
    fork(getVoucherDetail),
    fork(getMyVoucherDetail),
    fork(getMyVoucherList),
    fork(getPromo),
    fork(clearPromo),
    fork(loadVoucherMediaFood),
    fork(loadVoucherList),
    // fork(getRestaurantVoucher),
    fork(refundVoucher),
    fork(redeemVoucher),
    fork(buyVoucher),
    fork(loadAllVoucher),
  ]);
}
